import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ViewVolopPageLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ViewVolopPage" */
      './ViewVolopPage.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
